import './Loader.css';
import { useEffect, useState } from 'react';

function Loader(props) {
    const [hide, setHide] = useState(false);

    useEffect(() => {
        if (!props.hide) {
            setHide(false);
            return;
        }

        setHide(false);
        const timeoutId = setTimeout(() => setHide(true), props.hide);

        return () => {
            clearTimeout(timeoutId);
        };
    }, [props.hide]);

    return(
        <div className={`loader ${props.hidden || hide ? 'hidden' : ''} ${props.className || ''}`}>
            <span className='mouth-outer'><span className='mouth'></span></span>
            <span className='eye1'></span>
            <span className='eye2'></span>
        </div>
    );
  }

export default Loader;
